import styled, { css } from 'styled-components';
import {
    Screen,
    screenBiggerThan,
    screenSmallerThan,
} from '@client/styles/styled-components/breakpoints';

export const Image = styled.div<{
    animated: boolean;
    clickable: boolean;
    active: boolean;
    next: boolean;
    previous: boolean;
    lastChance: boolean;
}>`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background-position: center top;
    background-size: cover;
    background-repeat: no-repeat;

    ${({ clickable }) =>
        clickable &&
        css`
            cursor: pointer;
        `};

    &::after {
        content: ' ';
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        display: block;

        ${screenBiggerThan(Screen.smallTablet)} {
            display: none;
        }
    }

    ${({ animated, next, previous }) =>
        animated &&
        css`
            transition: left 500ms ease-in-out;

            ${screenBiggerThan(Screen.smallTablet)} {
                transition: none;

                ${(next || previous) &&
                css`
                    transition: opacity 500ms ease-out;
                    opacity: 0;
                    left: 0;
                    z-index: 1;
                `};
            }
        `};

    ${({ active }) =>
        active &&
        css`
            left: 0;
            opacity: 1;

            ${screenBiggerThan(Screen.smallTablet)} {
                transition: opacity 500ms ease-in;

                &::after {
                    content: ' ';
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    z-index: 10;
                    display: block;
                }
            }
        `};

    ${({ next }) =>
        next &&
        css`
            left: 100%;
            opacity: 1;
            ${screenBiggerThan(Screen.smallTablet)} {
                opacity: 0;
            }
        `};

    ${({ previous }) =>
        previous &&
        css`
            left: -100%;
            opacity: 1;
            //adding opacity 0 so browser can calculate OPACITY transition between previous and next
            ${screenBiggerThan(Screen.smallTablet)} {
                opacity: 0;
            }
        `};

    ${({ lastChance }) =>
        lastChance &&
        css`
            background-position: 65% 0;
            ${screenBiggerThan(Screen.mobile)} {
                background-position: center top;
            }
        `};

    .grid-page-layout {
        ${screenSmallerThan(Screen.smallTablet)} {
            padding-left: 0;
            padding-right: 0;
        }
    }
`;
